import React from "react"

const Info = () => (
  <p>
    <span className="field">Name:</span> Emmi Koistinen.
    <br />
    <span className="field">From:</span> Helsinki, Finland.
    <br />
    <span className="field">Who:</span> Amateur freetime artist.
    <br />
    <span className="field">What:</span> I do acrylic and watercolor paintings 
    and some digital art with drawing board. I also do logo clothes with 
    fabric paints.
  </p>
)

export default Info
